<template>
  <div id="app" class="app">
    <AppHeader />
    <router-view class="router-view" />
    <footer>
      <p>Copyright &copy; 2020 James Steinbach. All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'

export default {
  components: {
    AppHeader
  }
}
</script>

<style lang="scss">
@import "@/assets/global";

@font-face {
  font-family: Quicksand;
  font-weight: 300 900;
  src:
    url('/Quicksand-subset.woff2') format('woff2'),
    url('/Quicksand-subset.woff2') format('woff2 supports variations'),
    url('/Quicksand-subset.woff2') format('woff2-variations');
  font-display: swap;
}

html {
  height: -webkit-fill-available;
}

body {
  min-height: 100vh;
  // Mobile Safari viewport bug fix
  min-height: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  overflow-x: hidden;
  font-family: QuickSand, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  color: var(--color-page-fg, black);
  background-color: var(--color-page-bg, white);
  font-weight: 550;
}

.app {
  width: 100%;
  min-height: 100%;
  flex-grow: 1;
  display: grid;
  grid-template:
    "header" auto
    "content" 1fr
    "footer" auto /
    min(100%, 40rem);
  justify-content: center;

  > .router-view {
    padding: 0 1rem;
    max-height: 100%;
    overflow-y: auto;
    overflow-x: visible;
    -webkit-overflow-scrolling: touch;
  }

  > footer {
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    text-align: center;
    font-style: italic;
    opacity: .7;
  }
}

.u-screen-reader-only {
  position: absolute;
  height: 1px;
  width: 1px;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

a {
  color: #0D47A1;

  &:hover,
  &:active {
    color: #006064;
  }

  &:focus {
    outline: .125rem solid currentColor;
  }

  &:visited {
    color: #311B92;
  }
}

b,
strong {
  font-weight: 700;
}
</style>
